import { jsx } from "react/jsx-runtime";
import HomeIcon from "@mui/icons-material/Home";
import { validateTidalLicense } from "../../base/index.js";
function Home(props) {
  return /* @__PURE__ */ jsx(
    HomeIcon,
    {
      "data-testid": "Home",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Home",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Home.tidalIconMeta = {
  categories: "common,navigation",
  name: "Home"
};
validateTidalLicense();
export {
  Home
};
//# sourceMappingURL=Home.js.map
